import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/home.vue'
import MainLayout from '../layout/main.vue'
import UserLayout from '../layout/user.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: MainLayout,
    // redirect: '/user',
    name: 'home',
    meta: {
      title: '首页',
    },
    children: [
      {
        path: '',
        component: () => import('@/views/home/home.vue'),
        name: 'home',
        meta: { title: '首页'}
      },
      {
        path: '/list',
        component: () => import('@/views/list/list.vue'),
        name: 'list',
        meta: { title: '列表'}
      },
      {
        path: '/detail',
        name: 'detail',
        component: () => import('../views/detail/detail.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('../views/auth/register.vue')
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('../views/auth/login.vue')
      },
      {
        path: '/notice',
        name: 'notice',
        component: () => import('../views/notice/notice.vue')
      },
      {
        path: '/notice/detail',
        name: 'notice-detail',
        component: () => import('../views/notice/detail.vue')
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('../views/about/about.vue')
      },
      {
        path: '/contact',
        name: 'contact',
        component: () => import('../views/contact/contact.vue')
      },
    ]
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user',
    name: 'user',
    meta: {
      title: '用户中心',
    },
    children: [
      {
        path: 'assets/push',
        component: () => import('@/views/user/assets/push.vue'),
        name: 'assets-push',
        meta: { title: '资源发布'},
      },
      {
        path: 'assets/edit',
        component: () => import('@/views/user/assets/edit.vue'),
        name: 'assets-edit',
        meta: { title: '资源编辑' },
      },
      {
        path: 'assets/list',
        component: () => import('@/views/user/assets/list.vue'),
        name: 'assets-list',
        meta: { title: '资源管理'},
      },
      {
        path: 'password',
        component: () => import('@/views/user/password/password.vue'),
        name: 'password',
        meta: { title: '密码修改'},
      },
      {
        path: 'profile',
        component: () => import('@/views/user/profile/profile.vue'),
        name: 'profile',
        meta: { title: '个人资料'},
      }
    ]
  },
  {
    path: '/icp',
    name: 'icp',
    component: () => import('../views/icp/icp.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
